import {SelectedChipsData, SelectedZoomXData} from '@/components/controls/interfaces';
import {CursorType, DiagramActionType} from '@/enums/diagrams';
import {DiagramMode} from '@/interfaces/diagrams';

/*
  Состояние диаграммы для хранения в vuex
*/
export class CursorDiagramState {
  diagramId: string | null = null;

  activeModes: DiagramMode[] = [];

  isShowLine = true;

  isShowTooltips = false;

  isUpdateDiagram = true;

  cursorData: CursorData[] = [];

  actionData: Map<DiagramActionType, any> = new Map();

  selectedChipsData?: SelectedChipsData | null;

  selectedZoomXData?: SelectedZoomXData | null;

  constructor(state: CursorDiagramState | null = null) {
    if (!state) return;
    this.activeModes = [...state.activeModes];
    this.isShowLine = state.isShowLine;
    this.isShowTooltips = state.isShowTooltips;
    this.cursorData = [...state.cursorData];
    this.actionData = new Map(state.actionData);
    this.diagramId = state.diagramId;
    this.isUpdateDiagram = state.isUpdateDiagram;

    //TODO: может быть лучше копировать
    this.selectedChipsData = state.selectedChipsData;
    this.selectedZoomXData = state.selectedZoomXData;
  }
}

/*
  Класс, содержащий данные курсора
*/
export class CursorData {
  id: string;
  type: CursorType;
  pointX: number | undefined | null;
  linesCount: number | undefined | null;
  subLinesCount: number | undefined | null;
  subLinesFreqShift: number | undefined | null;

  constructor(
    id: string,
    type: CursorType,
    pointX: number | undefined | null,
    linesCount: number | undefined | null,
    subLinesCount: number | undefined | null,
    subLinesFreqShift: number | undefined | null,
  ) {
    this.id = id;
    this.type = type;
    this.pointX = pointX;
    this.linesCount = linesCount;
    this.subLinesCount = subLinesCount;
    this.subLinesFreqShift = subLinesFreqShift;
  }
}

export class MarkerCursorData extends CursorData {
  firstPointX: number | undefined | null;

  constructor(
    id: string,
    type: CursorType,
    pointX: number | undefined | null,
    firstPointX: number | undefined | null,
  ) {
    super(id, type, pointX, null, null, null);
    this.firstPointX = firstPointX;
  }
}
